import { lazy } from 'react';

const StaffPage = lazy(() =>
  import(/* webpackChunkName: "StaffDesktop" */ '@desktop/Staff/StaffPage')
);

export default StaffPage;
